import React,{useEffect, useRef} from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useState } from 'react'
import GrievanceForm from '../components/GrievanceForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';
import grievanceServices from '../grievanceServices';
import { Link } from 'react-router-dom';



const CellActions = (props) =>{
    return(
        <>
            <GrievanceForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
            <Link to={"/grievance/details/"+props.data.id} className='btn btn-sm btn-primary'>View</Link>
        </>
    )
  }


function GrievanceDashboardPage() {

  const {getMasterLabel} = useAppData();
  const [grievanceList,setGrievanceList] = useState();

  const getGrievanceList = () =>{
    grievanceServices.getList().then(res=>{
      setGrievanceList(res.data);
    }).catch(error=>{
      console.log(error);
    })
  }


  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {headerName: "Grievance Type", width:200,
          valueGetter:params=>{
            return getMasterLabel('grievance-type',params.data.grievanceType)
          }
        },
        {field:"customerName",headerName: "C Name",width:150},
        {field:"customerPhone",headerName: "C.Phone"},
        {field:"uid",headerName: "Unique Id"},
        {field:"textMessage",headerName: "Text Message",width:350},
        {field:"created_at",headerName: "Created On",width:150},
        {field:"updated_at",headerName: "Last Updated on",width:150},
        {headerName:"Action", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getGrievanceList,
                remove:remove
            },
        },      
    ];
    setColumnDef(_columnDefs);
  }

  const rowClassRules = {
        
        'bg-warning': params => params.data.grievanceStatus === 2,
        'bg-success': params => params.data.grievanceStatus === 3,
        'bg-danger': params => params.data.grievanceStatus === 4,
        'bg-dark text-white': params => params.data.grievanceStatus === 5,
        'bg-info': params => params.data.grievanceStatus === 6,
        
    };


  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <ErpLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Grievance</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><GrievanceForm callBack={getGrievanceList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12'>
          <span className='p-2 me-2 rounded border'>Open</span>
          <span className='p-2 me-2 rounded bg-warning'>In Progress</span>
          <span className='p-2 me-2 rounded bg-success'>Closed</span>
          <span className='p-2 me-2 rounded bg-danger'>Re Open</span>
          <span className='p-2 me-2 rounded bg-dark text-white'>Self Cancelled</span>
          <span className='p-2 me-2 rounded bg-info'>On Hold</span>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={grievanceList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowClassRules={rowClassRules}
                animateRows={true}
                onGridReady={getGrievanceList}
              />
            </div>
          </div>
        </div>
    </ErpLayout>
    
  )
}

export default GrievanceDashboardPage